import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HeroSection() {
  return <section className="relative bg-au-green text-white py-24 md:py-32" data-id="element-128" data-mp="qa0qqfu816dd">
      <div className="max-w-7xl mx-auto px-4" data-id="element-129" data-mp="uako9kipic01">
        <div className="max-w-4xl" data-id="element-130" data-mp="u99khkp9h48x">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-131" data-mp="u8gcyhihaapq">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif mb-6 leading-tight" data-id="element-132" data-mp="7c6abgqrjsky">
              Advancing Africa's Global Partnerships for Sustainable Development
            </h1>
            <div className="w-32 h-1 bg-au-gold mb-6" data-id="element-133" data-mp="21ow2nu1hgtq8"></div>
            <p className="text-xl md:text-2xl text-au-green-light mb-8 leading-relaxed" data-id="element-134" data-mp="25qhmy0gckaag">
              The African Union Commission connects Africa with partners across
              the world — driving transformative projects in health, education,
              trade, and infrastructure to foster prosperity and inclusive
              growth globally.
            </p>
            <div className="flex flex-wrap gap-4" data-id="element-135" data-mp="2k5wgk05t502x">
              <Link to="/projects" data-id="element-136" data-mp="2f6a3prtw5lun">
                <Button variant="primary" className="flex items-center gap-2" data-id="element-137" data-mp="2f71xcx3xh9ia">
                  Explore Our Projects
                  <ArrowRightIcon size={20} data-id="element-138" data-mp="1mgbcpqw4zenc" />
                </Button>
              </Link>
              <Link to="/bids" data-id="element-139" data-mp="1minxscx6y54m">
                <Button variant="secondary" className="bg-white" data-id="element-140" data-mp="21du83c3bkq3r">
                  View Current Bids
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-2 bg-au-gold" data-id="element-141" data-mp="3croaiq97rz10"></div>
    </section>;
}